<template>
    <slot :params="params" :items="items" :search="search" ></slot>
</template>

<script setup >
import { reactive, ref, computed, watch, defineProps } from 'vue';

const props = defineProps({
    delay : {
        type : Number,
        default : 800,
    },
});

const params = reactive({
    q : '',
    opened : false,
    elem : null,
});
const results = ref([]);
const items = computed(() => {
    if (!params.q) {
        return [];
    }
    let q_lCase = params.q.toLowerCase().trim();
    let items = {};
    results.value.forEach(res => {
        res.items.forEach(item => {
            if (res.q == q_lCase || ~item.name.toLowerCase().indexOf(q_lCase)) {
                items[ '_'+item.id ] = item;
            }
        });
    });
    return Object.values(items);
});
let searchTimeout = null;
watch(
    () => params.q,
    q => {
        clearTimeout(searchTimeout);
        if (q && !results.value.find(r => r.q == q)) {
            searchTimeout = setTimeout(()=>{
                search(q);
            }, (+props.delay || 800));
        }
    }
);

let clickOutsideHandler = e => {
    if (!params.elem.contains(e.target)) {
        params.opened = false;
    }
}
document.body.addEventListener('click', clickOutsideHandler);

const search = (q) => {
    if (!q) {
        return;
    }
    if (results.value.find(res => res.q == q)) {
        params.opened = true;
        return;
    }
    fetch(`/api/desktop/search/?q=${q}`)
        .then(res => res.json())
        .then(res => {
            if (res.data.items) {
                results.value.push({
                    q : q.toLowerCase().trim(),
                    items : res.data.items || [],
                });
                if (res.data.items.length) {
                    params.opened = true;
                }
            }
        });
}

</script>
